// IMPORTANT: keep `import` here — do not change it to `require()`. react-helmet-async ships two
// builds and its package "exports" map picks them by syntax: `import` resolves lib/index.esm.js,
// `require()` resolves lib/index.js. Every component imports it with `import`. A `require()` here
// makes webpack bundle BOTH files, each with its own React context, so <Helmet> in the components
// cannot find this HelmetProvider and the build crashes ("Cannot read properties of undefined
// (reading 'add')"). gatsby-ssr.js / gatsby-browser.js may still `require()` THIS file.
import React from 'react'
import { HelmetProvider } from 'react-helmet-async'

/**
 * Shared root provider for BOTH `gatsby-ssr.js` and `gatsby-browser.js`, for the same reason as
 * src/wrap-page-element.js: a provider registered in only one entry point exists in only that
 * environment. react-helmet-async throws when a `<Helmet>` renders without a `HelmetProvider`
 * above it, so a server-only provider would break every page on the client.
 *
 * The server passes a fresh per-render `context` (see src/helmet-server-context.js) that
 * `onRenderBody` reads the collected head back from. The browser passes none, and
 * `HelmetProvider` then updates `document.head` itself on client-side navigation.
 *
 * This is a helper rather than a ready-made hook because Gatsby calls hooks with
 * `(apiArgs, pluginOptions)` — exporting one function as both hooks would hand the browser's
 * plugin options to `HelmetProvider` as its context.
 */
export const wrapWithHelmetProvider = (element, context) =>
  React.createElement(HelmetProvider, context ? { context } : null, element)
